import React from 'react';
import Box from '@mui/material/Box';
import PageLayout from '../PageLayout';

/**
 * Dashboard page base for entities with few attributes/records (Roles, and
 * similarly small entities) — bounds header + body to the same centered
 * max-width, instead of stretching to fill the viewport like the plain
 * `PageLayout` (the base for large/many-column entities, e.g. Leads).
 *
 * Extracted from the Roles list/form/detail pages: keep using this (not
 * one-off `sx={{ maxWidth, mx: 'auto' }}` per page) so header and body always
 * line up, and so every small-entity CRUD page shares the same width rule.
 */
export default function BoundedPageLayout({ header, children, maxWidth = 'lg' }) {
  return (
    <PageLayout
      header={
        header && (
          <Box sx={{ width: '100%', maxWidth, mx: 'auto' }}>{header}</Box>
        )
      }
    >
      <Box
        sx={{
          width: '100%',
          maxWidth,
          mx: 'auto',
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {children}
      </Box>
    </PageLayout>
  );
}
